import React from "react";
import {requestAction} from "domain/typeConstants/action";
import AddIcon from "@material-ui/icons//AddCircleOutline";

export const addActionButton = {
    name: requestAction.ADD,
    svgIcon: <AddIcon/>
};
